/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  incomeGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  incomeItem: {
    width: '48%',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
    marginRight: '2%',
  },
  radioButton: {
    width: 8,
    height: 8,
    borderRadius: 4,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#ffffff',
  },
  selectedRadio: {
    width: 8,
    height: 8,
    borderRadius: 4,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#27ae60',
  },
  radioText: {
    fontSize: 9,
    color: '#2c3e50',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  signatureBox: {
    width: '45%',
    padding: 10,
    border: '1px solid #bdc3c7',
    borderRadius: 5,
  },
  signatureTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#34495e',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },

  note: {
    fontSize: 8,
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginBottom: 10,
  }
});

const ExportPDFEmployerIncomeTaxDeclaration = ({ user, data,agencyInfo }) => {


  const incomeRanges = [
    'Below $2,000',
    '$2,000-$2,499',
    '$2,500-$2,999',
    '$3,000-$3,499',
    '$3,500-$3,999',
    '$4,000-$4,999',
    '$5,000-$5,999',
    '$6,000-$7,999',
    '$8,000-$9,999',
    '$10,000-$12,499',
    '$12,500-$14,999',
    '$15,000-$19,999',
    '$20,000-$24,999',
    '$25,000 and above'
  ];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Annex A – Employer and Spouse Income Tax Declaration</Text>
        
        {/* Part I - Monthly Combined Income */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Part I – Monthly Combined Income</Text>
          <Text style={styles.note}>Please tick the appropriate box:</Text>
          
          <View style={styles.incomeGrid}>
            {incomeRanges.map((range, index) => (
              <View key={index} style={styles.incomeItem}>
                <View style={data.incomeRange === range ? styles.selectedRadio : styles.radioButton} />
                <Text style={styles.radioText}>{range}</Text>
              </View>
            ))}
          </View>
          
          {data.incomeRange && (
            <View style={styles.row}>
              <View style={styles.column}>
                <Text style={styles.label}>Selected Income Range:</Text>
                <Text style={styles.value}>{data.incomeRange}</Text>
              </View>
            </View>
          )}
        </View>

        {/* Part II - Authorisation */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Part II – Authorisation</Text>
          <Text style={styles.note}>Authorisation by Employer and/or Spouse to Comptroller of Income Tax:</Text>
          
          <View style={styles.signatureSection}>
            {/* Employer Section */}
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Employer</Text>
              <Text style={styles.label}>Name:</Text>
              <Text style={styles.value}>{data.employerName || ''}</Text>
              
              <Text style={styles.label}>NRIC / WP No / FIN:</Text>
              <Text style={styles.value}>{data.employerNric || ''}</Text>
              
              <Text style={styles.label}>Income Tax Notice of Assessment No:</Text>
              <Text style={styles.value}>{data.employerNOA || ''}</Text>
              
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.employerSignature || ''}</Text>
              
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.employerDate || ''}</Text>
            </View>

            {/* Spouse Section */}
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Spouse</Text>
              <Text style={styles.label}>Name:</Text>
              <Text style={styles.value}>{data.spouseName || ''}</Text>
              
              <Text style={styles.label}>NRIC / WP No / FIN:</Text>
              <Text style={styles.value}>{data.spouseNric || ''}</Text>
              
              <Text style={styles.label}>Income Tax Notice of Assessment No:</Text>
              <Text style={styles.value}>{data.spouseNOA || ''}</Text>
              
              <Text style={styles.label}>Signature:</Text>
              <Text style={styles.value}>{data.spouseSignature || ''}</Text>
              
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.spouseDate || ''}</Text>
            </View>
          </View>
        </View>

        {/* Declaration Text */}
        <View style={styles.section}>
          <Text style={styles.note}>
            I/We hereby authorise the Comptroller of Income Tax to disclose to the Ministry of Manpower 
            the details of my/our total income assessed for income tax purposes for the relevant year of assessment 
            for the purpose of determining my/our eligibility to employ a foreign domestic worker.
          </Text>
          <Text style={styles.note}>
            I/We understand that this authorisation will remain valid until revoked in writing by me/us.
          </Text>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Employer Income Tax Declaration Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFEmployerIncomeTaxDeclaration;
